import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

import Handsontable from 'handsontable';
import { registerAllModules } from 'handsontable/registry';

import {
  isgRendererNumeric,
  isgRendererPercentage,
  isgRendererHeatMapSingle,
  isgRendererHeatMapSinglePerc,
  isgRendererHeatMapDouble,
  isgRendererHeatMapDoublePerc,
  isgRendererDropDownValidation,
  isgRendererDropDownNoValidation,
  isgValidatorDropDownNoValidation
} from './app/features/prob/handson';

import { appConfig } from './app/app.config';

// Register all Handsontable modules
registerAllModules();

// Register custom Handsontable renderers/validators
Handsontable.renderers.registerRenderer('isg.numeric', isgRendererNumeric);
Handsontable.renderers.registerRenderer('isg.percentage', isgRendererPercentage);
Handsontable.renderers.registerRenderer('isg.heatmap.single', isgRendererHeatMapSingle);
Handsontable.renderers.registerRenderer('isg.heatmap.single.perc', isgRendererHeatMapSinglePerc);
Handsontable.renderers.registerRenderer('isg.heatmap.double', isgRendererHeatMapDouble);
Handsontable.renderers.registerRenderer('isg.heatmap.double.perc', isgRendererHeatMapDoublePerc);
Handsontable.renderers.registerRenderer('isg.dropdown.validation', isgRendererDropDownValidation);
Handsontable.renderers.registerRenderer('isg.dropdown.novalidation', isgRendererDropDownNoValidation);
Handsontable.validators.registerValidator('isg.dropdown.validationOff', isgValidatorDropDownNoValidation);

// Bootstrap
fetch('/assets/configuration/appconfig.json')
  .then(r => r.json())
  .then(settings => {
    if (environment.production) {
      enableProdMode();
    }

    return bootstrapApplication(
      AppComponent,
      appConfig(settings)
    );
  })
  .catch(err => console.error(err));
